<template>
  <div class="box--detail">
    <div class="detail">
      <div class="banner"></div>
      <!-- <div class="home-btn" @click="toHome()"></div> -->
      <div class="main-content">
        <span class="pc-back" @click="back"></span>
        <span class="divider"></span>
        <template v-if="article">
          <h1 class="title">{{ article.articleTitle }}</h1>
          <div class="news-info-content">
            <span class="time">{{ article.deployTime }}</span>
          </div>
          <p class="p-detail" v-html="article.articleContent"></p>
          <!-- <div class="p-content">
          <p class="p-detail">
            {{ first_paragraph }}
          </p>
        </div>
        <div v-for="content in contents" :key="content.id" class="p-content">
          <img v-if="content.img" :src="content.img" alt="" />
          <div style="text-align: center;font-size:0.15rem;margin:-0.3rem 0 0.3rem 0;" v-if="content.imgMsg">{{content.imgMsg}}</div>
          <h1 v-if="content.subTitle" class="p-title">
            {{ content.subTitle }}
          </h1>
          <p class="p-detail" v-html="content.paragraph"></p>
        </div> -->
        </template>
      </div>
    </div>
    <!-- 浮窗 -->
    <SiderBar />
  </div>
</template>

<script>
import SiderBar from '../components/SiderBar';
import { getArticleById } from '@/api/index.js';
export default {
  data() {
    return {
      article: null,
    };
  },
  async created() {
    const articleId = this.$route.query.id;
    const res = await getArticleById({
      gameCode: 'ddj-vn',
      articleId,
    });
    this.article = res?.data ?? null;
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    toHome() {
      this.$router.push('/');
    },
  },
  components: {
    SiderBar,
  },
};
</script>

<style lang="scss">
// app
.box--detail {
  display: flex;
  flex-direction: column;
}
@media screen and (max-width: 768px) {
  .box--detail {
    display: flex;
    flex-direction: column;
    min-height: calc(100vh - 288px);
  }
  .detail {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    background: url(https://cdn-game-activity.23you.net/frontend/ddj-official-vietnam/assets/m_details.png) 0 0 no-repeat;
    background-size: 100%;

    .banner {
      width: 100%;
      height: 460px;
      // background: url(https://staticweb.ewan.cn/resources/img/ddj-tw/m_detial_banner.jpg)
      //   no-repeat 0 0;
      // background-size: cover;
    }

    .home-btn {
      display: none;
    }

    .main-content {
      width: 100%;
      position: relative;
      padding: 0px 30px 93px 30px;
      .pc-back {
        top: 15px;
        left: 20px;
        width: 42px;
        height: 42px;
        position: absolute;
        cursor: pointer;
        background: url(https://staticweb.ewan.cn/resources/img/ddj-tw/back_btn.png)
          no-repeat 0 0;
        background-size: 100%;
      }

      .divider {
        position: absolute;
        top: 73px;
        left: 0;
        width: 100%;
        height: 1px;
        background-color: #dfbd99;
      }

      .title {
        margin: 134px 0 0 0;
        color: #404040;
        text-align: center;
        font-size: 34px;
        line-height: 36px;
        font-family: 'GenJyuuGothic-P-Regular';
      }
      .news-info-content {
        margin: 30px 0px 43px 0px;
        font-family: 'GenJyuuGothic-P-Regular';
        font-size: 24px;
        line-height: 29px;
        text-align: center;
        color: #404040;
        .time {
          margin: 0 0 0 22px;
        }
        span {
          text-align: center;
        }
      }

      .p-detail {
        img {
          margin: 30px auto 30px auto;
          width: 100%;
          display: block;
          object-fit: contain;
        }
      }

      .p-detail {
        img {
          margin: 30px auto 30px auto;
          width: 100%;
          display: block;
          object-fit: contain;
        }
      }

      // .p-content {
      //   .p-title {
      //     font-size: 22px;
      //     color: #bf703c;
      //     margin: 35px 0px;
      //     line-height: 29px;
      //     text-align: left;
      //     font-family: 'GenJyuuGothic-P-Regular';
      //   }
      //   img {
      //     margin: 30px auto 30px auto;
      //     width: 100%;
      //     display: block;
      //     object-fit: contain;
      //   }
      //   .p-detail {
      //     font-size: 19px;
      //     font-weight: normal;
      //     font-stretch: normal;
      //     letter-spacing: 1px;
      //     color: #404040;
      //     line-height: 45px;
      //     font-family: 'GenJyuuGothic-P-Regular';
      //     white-space: pre-wrap;
      //     table {
      //       margin: 0 auto;
      //       border-top: 1px solid #000000;
      //       border-left: 1px solid #000000;
      //       border-collapse: collapse; /*设置单元格的边框合并为1*/
      //     }
      //     td {
      //       border-bottom: 1px solid #000000;
      //       border-right: 1px solid #000000;
      //       text-align: center;
      //       padding: 8px 20px;
      //     }
      //   }
      // }
    }
  }
}
// pc
@media screen and (min-width: 769px) {
  .box--detail {
    min-height: calc(100vh - 180px);
  }
  .detail {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    background: url(https://cdn-game-activity.23you.net/frontend/ddj-official-vietnam/assets/pc_details.png) 0 0 no-repeat;
    background-size: 100%;

    .banner {
      width: 100%;
      height: 324px;
      // background: url(https://staticweb.ewan.cn/resources/img/ddj-tw/detail_banner.jpg)
      //   no-repeat 0 0;
      // background-size: cover;
    }

    .home-btn {
      position: absolute;
      width: 163px;
      height: 49px;
      left: 143px;
      top: 204px;
      background: url(https://staticweb.ewan.cn/resources/img/ddj-tw/list_back.png)
        no-repeat 0 0;
      background-size: cover;
    }

    .main-content {
      width: 924px;
      position: relative;
      padding: 80px 0px 127px 0px;
      .pc-back {
        width: 42px;
        height: 42px;
        top: 76px;
        position: absolute;
        cursor: pointer;
        background: url(https://staticweb.ewan.cn/resources/img/ddj-tw/back_btn.png)
          no-repeat 0 0;
        background-size: 100%;
      }

      .title {
        color: #404040;
        text-align: center;
        font-size: 34px;
        line-height: 40px;
        width: 800px;
        position: relative;
        left: 50%;
        margin-left: -400px;
        font-family: 'GenJyuuGothic-P-Medium';
      }
      .news-info-content {
        margin: 30px 0px 36px 0px;
        font-family: 'GenJyuuGothic-P-Regular';
        font-size: 24px;
        line-height: 29px;
        color: #404040;
        .time {
          margin: 19px 0 0 0;
          font-family: 'NotoSansCJKsc-Regular';
        }
        span {
          display: block;
          text-align: center;
        }
      }

      // .p-content {
      //   .p-title {
      //     font-size: 22px;
      //     color: #bf703c;
      //     margin: 35px 0px;
      //     line-height: 29px;
      //     text-align: left;
      //     font-family: 'NotoSansCJKsc-DemiLight';
      //   }
      //   img {
      //     margin: 40px auto 40px auto;
      //     max-width: 924px;
      //     display: block;
      //     object-fit: contain;
      //   }
      //   .p-detail {
      //     font-size: 19px;
      //     font-weight: normal;
      //     font-stretch: normal;
      //     letter-spacing: 1px;
      //     color: #404040;
      //     line-height: 45px;
      //     font-family: 'GenJyuuGothic-P-Regular';
      //     white-space: pre-wrap;
      //     table {
      //       margin: 0 auto;
      //       border-top: 1px solid #000000;
      //       border-left: 1px solid #000000;
      //       border-collapse: collapse; /*设置单元格的边框合并为1*/
      //     }
      //     td {
      //       border-bottom: 1px solid #000000;
      //       border-right: 1px solid #000000;
      //       text-align: center;
      //       padding: 8px 20px;
      //     }
      //   }
      // }
    }
  }
}
</style>
